<template>
  <section class="breadcrumb" v-if="category">
    <div class="inner">
      <page-link :to="category.url">{{category.name}}</page-link>
      <i class="fa fa-chevron-right"></i>
      {{page.name}}
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "Breadcrumb",
  computed: {
    ...mapState(["page", "categories"]),
    category: function() {
      if (this.page.ItemID && this.categories) return this.categories.filter(cat => cat.ItemID == this.page.ParentID)[0]
      return null
    }
  }
}
</script>

<style scoped>
.breadcrumb {
  padding: 2rem 0;
  font-size: 1.3rem;
}

.breadcrumb i {
  display: inline-block;
  padding: 0 1rem;
  color: #dfdfdf;
}

@media screen and (max-width: 750px) {
}
</style>
